import React, { Component } from "react";
import { Switch } from "react-router-dom";

import PrivateRoute from "../shared/components/misc/PrivateRoute";

import Intro from './components/Intro';

class CreditLimitRoutes extends Component {
  render() {
    return (
      <Switch>
        <PrivateRoute
          exact
          path="/credit-limit/intro"
          component={Intro}
        />
      </Switch>
    );
  }
}

export default CreditLimitRoutes;



// WEBPACK FOOTER //
// ./src/features/CreditLimit/routes.js